import { NgModule } from '@angular/core';

import { DsSegmentedControl } from './segmented-control.component';
import { DsSegmentedOption } from './segmented-option.component';

export { DsSegmentedOption, DsSegmentedControl };

@NgModule({
    imports: [DsSegmentedControl, DsSegmentedOption],
    exports: [DsSegmentedControl, DsSegmentedOption],
})
export class DsSegmentedControlModule {}
